module.exports = __webpack_public_path__ + "img/join4-4.9d3efdad.svg";